<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <v-card>
      <v-toolbar
        flat
        color="primary"
        dark
        dense
      >
        <v-icon left>mdi-sign-text</v-icon>
        Information Headers
        <v-spacer />
      </v-toolbar>
      <v-expand-transition>
        <v-card-text
          v-if="!loading"
        >
          <v-alert
            :value="true"
            type="info"
            outline
          >
            This adds informational headers to the specified pages on the Contact side
          </v-alert>

          <v-switch
            label="Replace Welcome Message"
            v-model="enable_welcome_modal"
          />

          <Editor
            v-show="enable_welcome_modal"
            ref="welcomeEditor"
            :html="orgSettings.contact_welcome_modal"
            :enable_html="true"
            height="250"
            :min="25"
          />

          <v-switch
            label="Add Files Header"
            v-model="enable_files_info"
          />

          <Editor
            v-show="enable_files_info"
            ref="filesEditor"
            :html="orgSettings.contact_files_info"
            :enable_html="true"
            height="250"
            :min="25"
          />
          <v-switch
            label="Add Messages Header"
            v-model="enable_message_info"
          />

          <Editor
            v-show="enable_message_info"
            ref="messagesEditor"
            :html="orgSettings.contact_messages_info"
            :enable_html="true"
            height="250"
            :min="25"
          />
          <v-switch
            label="Add Cases Header"
            v-model="enable_cases_info"
          />

          <Editor
            v-show="enable_cases_info"
            ref="casesEditor"
            :html="orgSettings.contact_cases_info"
            :enable_html="true"
            height="250"
            :min="25"
          />
        </v-card-text>
      </v-expand-transition>
      <v-card-actions>
        <div
          v-if="htmlerr"
          style="display: inline-block"
        >
          Check your Subject and Message Body and Try Again
        </div>
        <v-spacer />
        <v-btn
          :disabled="loading || (orgSettings.auto_reply && !valid)"
          color="primary"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import Editor from '@/components/admin/Editor'
import { Sketch } from 'vue-color'
import appMixin from '@/components/global/appmixin.js'

export default {
  name: 'OrgCommunicationAutoReply',
  mixins: [
    appMixin
  ],
  components: {
    Editor,
    'sketch-picker': Sketch,
  },
  data () {
    return {
      loading: false,
      enable_welcome_modal: false,
      enable_message_info: false,
      enable_cases_info: false,
      enable_files_info: false,
      valid: true,
      orgSettings: {},
      htmlerr: false,
      placeholders: [
        {
          scope: "contact",
          variable: "first_name",
          name: "Contact: First Name",
        },
        {
          scope: "contact",
          variable: "middle_name",
          name: "Contact: Middle Name",
        },
        {
          scope: "contact",
          variable: "last_name",
          name: "Contact: Last Name"
        },
        {
          scope: "contact",
          variable: "full_name",
          name: "Contact: Full Name (Last, Middle First)"
        },
        {
          scope: "contact",
          variable: "cuid",
          name: "Contact: CUID"
        },
        {
          scope: "contact",
          variable: "email",
          name: "Contact: Email"
        },
        {
          scope: "contact",
          variable: "phone",
          name: "Contact: Phone"
        }
      ]
    }
  },
  created () {
    this.documentTitle('Organization Settings')
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      api.auth.organization.get()
        .then(org => {
          this.orgSettings = org
          delete this.orgSettings.logo
          delete this.orgSettings.icon
          if (this.orgSettings.contact_welcome_modal)
            this.enable_welcome_modal = true
          if (this.orgSettings.contact_cases_info)
            this.enable_cases_info = true
          if (this.orgSettings.contact_files_info)
            this.enable_files_info = true
          if (this.orgSettings.contact_messages_info)
            this.enable_message_info = true
          this.loading = false
        })
    },
    save () {
      this.failed = false
      this.loading = true
      this.htmlerr = false
      if (this.enable_cases_info) {
        this.orgSettings.contact_cases_info = this.$refs.casesEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      } else {
        this.orgSettings.contact_cases_info = null
      }
      if (this.enable_files_info) {
        this.orgSettings.contact_files_info = this.$refs.filesEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      } else {
        this.orgSettings.contact_files_info = null
      }
      if (this.enable_message_info) {
        this.orgSettings.contact_messages_info = this.$refs.messagesEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      } else {
        this.orgSettings.contact_messages_info = null
      }
      if (this.enable_welcome_modal) {
        this.orgSettings.contact_welcome_modal = this.$refs.welcomeEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      } else {
        this.orgSettings.contact_welcome_modal = null
      }
      api.auth.organization.save(this.orgSettings)
        .then(() => {
          this.$router.go()
        })
        .catch(() => {
          alert('Something went wrong attempting to update organization settings.')
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
  .details span {
    display:block;
    padding:3px;
  }

  .uploadHover {
    position: absolute;
    padding:50px;
    width:100%;
    height:100%;
    top:40px;
    bottom:0;
    background:rgba(255,255,255,0);
    opacity:0.05;
  }

  .uploadHover span {
    font-size:18px;
    text-align:center;
  }

  .uploadHover:hover {
    opacity:1;
    background:rgba(255,255,255,0.5);
  }
</style>
